<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  #notificationModalContent {
    display: grid;
    position: relative;
    background: linear-gradient(180deg, #e0f2fa 0%, #fff 57.86%);
    text-align: center;
    width: 600px;
    height: 100%;
    gap: 1rem;
    border-radius: 0.5rem;
    border: 4px solid white;
    overflow-y: auto;

    .hidden-section {
      visibility: hidden;
      background-color: transparent;
    }

    .image-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 330px;
      pointer-events: none;

      &.with-gradient::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 50%;
        background: linear-gradient(
          180deg,
          rgba(224, 242, 250, 0) 0%,
          rgb(249 252 254) 100%
        );
      }
    }

    .image-container img {
      position: relative;
      &.svg-image {
        z-index: 1;
      }
    }

    .content-container {
      display: grid;
      padding: 0rem 4rem;
      gap: 0.2rem;

      span {
        font-size: 0.7rem;
        color: $primary-color;
        font-weight: bold;
      }

      h3 {
        color: $text-black;
        font-size: 1.2rem;
        max-width: 340px;
        line-height: 1.2;
        margin: 0 auto;
      }

      p {
        font-size: 0.8rem;
        max-width: 450px;
        margin: 1rem auto;
        height: 55px;
      }
    }

    .bottom-section {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f0f0f0;
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
      padding: 0.5rem;
    }

    .close-button {
      position: absolute;
      top: 1rem;
      right: 1rem;
      color: $text-gray;
      font-size: 1.5rem;
      border: none;
      background: 0;

      &:hover {
        opacity: 0.7;
      }
    }
  }
</style>

<script>
  import { updateTask } from "../../../api/training-hub";
  import ActionButton from "./Components/ActionButton.svelte";
  import Modal from "./Components/Modal.svelte";
  import ProgressContainer from "./Components/ProgressContainer.svelte";

  export let showModal = false;
  export let modalSteps = [];
  export let hideCloseButtonOnFirst = false;
  export let modalId = "";

  let currentStep = 0;

  const isSvg = (image) => image.endsWith(".svg");

  const modalConfig = {
    trainingWelcomeModal: {
      taskId: "shownWelcomeModal",
    },
    trainingCompletionModal: {
      taskId: "shownCompletionModal",
      userType: "viewer",
    },
  };

  const closeModal = () => {
    showModal = false;

    const config = modalConfig[modalId];

    updateTask({ taskId: config.taskId, userType: config.userType });
  };
</script>

{#if showModal}
  <Modal bind:showModal maxHeight="700px">
    <div id="notificationModalContent">
      {#if !(hideCloseButtonOnFirst && currentStep === 0)}
        <button
          class="close-button"
          on:click={() => closeModal()}
          aria-label="Close modal"
        >
          <i class="fa-solid fa-times"></i>
        </button>
      {/if}
      {#each modalSteps as step, index}
        {#if index === currentStep}
          <div
            class="image-container"
            class:with-gradient={step.showGradient ?? true}
            style={step.backgroundImage
              ? `background-image: url('${step.backgroundImage}')`
              : ""}
          >
            <img
              src={step.image}
              alt="Welcome step {index + 1}"
              class={isSvg(step.image) ? "svg-image" : ""}
              style="height: {step.imageHeight}px;"
            />
          </div>
          <div class="content-container">
            <span>{step.title}</span>
            <h3>{step.subtitle}</h3>
            <p>{step.content}</p>
          </div>
        {/if}
      {/each}
      <div class:hidden-section={modalSteps.length === 1}>
        <ProgressContainer bind:currentStep totalSteps={modalSteps.length} />
      </div>
      <div
        class="bottom-section"
        class:hidden-section={currentStep !== modalSteps.length - 1}
      >
        <ActionButton
          style="height:50px;"
          class="primary"
          onclick={() => closeModal()}
        >
          {modalSteps[currentStep]?.ctaText || ""}
        </ActionButton>
      </div>
    </div>
  </Modal>
{/if}
